<template>
    <div class="contain">
        <div class="bg-white myTabs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="全部">
                    <list ref="全部" statusText="全部"></list>
                </el-tab-pane>
                <el-tab-pane label="未开始" name="未开始">
                    <list ref="未开始" statusText="未开始"></list>
                </el-tab-pane>
                <el-tab-pane label="进行中" name="进行中">
                    <list ref="进行中" statusText="进行中"></list>
                </el-tab-pane>
                <el-tab-pane label="已结束" name="已结束">
                    <list ref="已结束" statusText="已结束"></list>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import list from './components/list'
export default {
    name: 'operation_promotionList',
    components: {
        list
    },
    data() {
        return {
            searchString: 'title',
            searchContent: undefined,
            tableData: [],
            searchParams: {
                pageSize: 20,
                pageNumber: 1
            },
            total: 0,
            activeName: '全部'
        }
    },
    mounted() {
        this.$refs[this.activeName].getList()
    },
    methods: {
        handleClick(tab) {
            this.$refs[tab.label].getList()
        }
    },
}
</script>

<style lang="scss">
.contain {
    margin: 4px 10px;
    min-width: 1400px;
    .topBreadcrumb {
        margin-bottom: 10px;
    }
    .myTabs {
        padding: 4px 10px;
    }
    .list {
        padding: 0 10px 10px 10px;
    }
}
</style>